<template>
    <Head v-if="!loading" :title="__('Test Case')" />
    <div class="task__details">
        <div class="wrapper" id="modal">
            <div role="alert" class="container">
                <div v-if="loading" class="content">
                    <div role="status" class="td__loader">
                        <div class="__f"><div class="i__r" /></div>
                        <div class="__f"><div><div class="i__1" /></div></div>
                        <div class="__f"><div><div class="i__1" /></div></div>
                        <div class="__f"><div><div class="i__1" /></div></div>
                        <div class="__f"><div><div class="i__1" /></div></div>
                        <div class="__f"><div><div class="i__1" /></div></div>
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                <div v-else>
                    <div class="content">                        
                        <div class="close_area">
                            <div class="wrap">
                                <span @click="$emit('closeModal', true)" class="close__b">
                                    <icon class="h-6 w-6" name="close" />
                                </span>
                            </div>
                        </div>                      
                        <div class="m__body">
                            <main class="main overflow-y-auto h-full">
                                <div class="flex justify-between mt-4 mb-2">
                                    <button 
                                        class="bg-indigo-600 text-white p-[5px] rounded disabled:opacity-50 text-sm" 
                                        @click="addTestStep()" 
                                        v-if="role.slug === 'admin' || role.access.testcase.testscript"
                                    >Add Steps</button>
                                    <button v-if="showStepInput" class="bg-indigo-600 text-white p-[5px] rounded disabled:opacity-50 text-sm" @click="updateStep()">Update</button>
                                </div>
                                <div v-if="showStepInput" class="grid gap-6 mb-6 md:grid-cols-3">
                                    <div>
                                        <label for="step" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">STEP(*)</label>
                                        <quill-editor ref="step" v-model:content="step.step" class="task__description" :options="editorOptions" contentType="html" theme="snow" />
                                    </div>
                                    <div>
                                        <label for="data" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">TEST DATA</label>
                                        <quill-editor ref="data" v-model:content="step.test_data" class="task__description" :options="editorOptions" contentType="html" theme="snow" />
                                    </div>
                                    <div>
                                        <label for="result" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">EXPECTED RESULT(*)</label>
                                        <quill-editor ref="result" v-model:content="step.expected_result" class="task__description" :options="editorOptions" contentType="html" theme="snow" />
                                    </div>  
                                </div>  
                                <div class="flex flex-col task__table">
                                    <div class="inline-block min-w-full h-full py-4 align-middle">
                                        <div class="table__view">
                                            <table>
                                                <thead>
                                                <tr>
                                                    <th scope="col" class="w-[20px]">
                                                    </th>
                                                    <th scope="col" class="w-[calc(32%-70px)]]">
                                                        <button class="flex items-center gap-x-3 focus:outline-none">
                                                            <span>{{ __('Test Step') }}</span>
                                                        </button>
                                                    </th>

                                                    <th scope="col" class="w-[17%]">
                                                        {{ __('Test Data') }}
                                                    </th>

                                                    <th scope="col" class="w-[17%]">
                                                        {{ __('Test Result') }}
                                                    </th>

                                                    <th scope="col" class="w-[17%]" v-if="role.slug === 'admin' || role.access.testcase.testscript">
                                                        {{ __('Action') }}
                                                    </th>
                                                </tr>
                                                </thead>
                                                <draggable tag="tbody" handle=".handle" class="t__drag" :list="testScripts" group="task" item-key="id" @end="afterDrop($event)"  :disabled="role.slug !== 'admin' || !role.access.testcase.testscript">
                                                        <template #item="{ element, index }">
                                                            <tr class="list-group-item group" :data-id="element.id">
                                                                <td class="pl-2 pr-0 opacity-0 group-hover:opacity-100 py-2 border-none text-sm font-medium whitespace-nowrap w-[20px]">
                                                                    <div class="cursor-grab handle"><icon class="w-6 h-6" name="drag" /></div>
                                                                </td>
                                                                <td class="px-2 py-2 text-sm font-medium whitespace-nowrap w-[calc(32%-70px)] hover:bg-gray-100">
                                                                    <div class="cursor-pointer" :data-id="element.id" v-html="element.step"></div> 
                                                                </td>
                                                                <td class="px-2 hide_arrow py-2 text-sm font-medium whitespace-nowrap w-[17%] cursor-pointer hover:bg-gray-100">
                                                                    <div class="inline t__title text-sm font-normal rounded-full text-emerald-500 gap-x-2 bg-emerald-100/60 dark:bg-gray-800" v-html="element.test_data">
                                                                    </div>
                                                                </td>
                                                                <td class="px-1 py-1 hide_arrow t_label text-sm whitespace-nowrap w-[17%] cursor-pointer hover:bg-gray-100">
                                                                    <div class="inline t__title text-sm font-normal rounded-full text-emerald-500 gap-x-2 bg-emerald-100/60 dark:bg-gray-800" v-html="element.expected_result">
                                                                    </div>
                                                                </td>
                                                                <td class="px-2 py-2 text-sm whitespace-nowrap w-[50px] relative" v-if="role.slug === 'admin' || role.access.testcase.testscript">
                                                                    <button aria-label="Delete" data-a="" @click="deleteConfirm($event, element.id, index)" class="flex w-full items-center text-xs font-medium focus:outline-none focus:ring-0">
                                                                        <icon class="mr-2 h-4 w-4 " name="trash" />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </template>
                                                    </draggable>
                                                <tbody v-if="!testScripts.length">
                                                   
                                                <tr >
                                                    <td class="border-t px-6 py-4 text-center" colspan="7">{{ __('No steps found!') }}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </main>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <delete-confirmation v-if="deleteData.confirm" @popup="closeConfirm()" @confirm="deleteStep()"
    details="Are you sure want to delete this step?" />
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import Loader from '@/Shared/Loader'
import Datepicker from '@vuepic/vue-datepicker';
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import axios from 'axios'
import draggable from 'vuedraggable'
import DeleteConfirmation from "@/Shared/DeleteConfirmation";

export default {
    props: {
        project: Object,
        id: Number
    },
    emits: {closeModal: null},
    data() {
        return {
            loading: false,
            testScripts: [],
            showStepInput: false,
            role: this.$page.props.auth.user.role,
            deleteData: {
                id: null,
                index: null,
                confirm: false
            },
            step: {
                step: '',
                test_data: '',
                expected_result: '',
            },
            editorOptions: {
                modules: {
                    toolbar: {
                        container: [
                            'bold', 'italic', 'underline', { 'list': 'bullet' }, { 'list': 'ordered'},
                            'align',
                        ],
                        // handlers: { 'image': this.imageButtonClickHandler }
                    },
                    // imageDrop: true,
                }
            }
        }
    },
    components: {
        Icon, Loader, Link, QuillEditor, Head, draggable, DeleteConfirmation
    },
    computed: {

    },
    created() {
        this.getTestScript(this.id)
    },
    methods: {
        onEditorReady(editor){},
        addTestStep() {
            this.showStepInput = !this.showStepInput;
        },
        updateStep() {
            const step = { ...this.step, test_case_id: this.id };
            
            axios.post(this.route('json.testscript.create'), step).then((response) => {
                if(response.data){
                    this.showStepInput = false;
                    //clear inputs
                    this.step = {
                        step: '',
                        test_data: '',
                        expected_result: '',
                    }
                    this.getTestScript(this.id)
                }
            });
        },
        async getTestScript(id){
            this.loading = true
            const testCaseResponse = await axios.get(this.route('json.test_script.get', {uid:id}));
            this.testScripts = testCaseResponse.data
            this.loading = false
        },
        afterDrop(e){
            const new_list = this.newSortedItems(e, 'to');
            let previous_list = [];
            if(!!e.pullMode){
                previous_list = this.newSortedItems(e, 'from');
                this.saveTask(e.item.dataset.id, { list_id: e.to.dataset.id }, e.to.dataset.index)
            }
            const list_items = new_list.concat(previous_list);
            this.saveOrder(list_items)
        },
        newSortedItems(e, selector){
            const lists = e[selector].getElementsByTagName("tr");
            const newOrder = [];
            for (let i = 0; i < lists.length; i++) {
                newOrder.push({id: lists[i].dataset.id, sort: i+1})
            }
            return newOrder;
        },
        saveOrder(taskObject){
            axios.post(this.route('testscript.update.order'), taskObject).catch((error) => {
                console.log(error)
            })
        },
        deleteConfirm(e, id, index){
            e.preventDefault();
            this.deleteData = {id, index, confirm: true}
        },
        deleteStep(){
            console.log(this.deleteData.id)
            const _this = this;
            axios.delete(this.route('testscript.delete', this.deleteData.id)).then(function(response) {
                _this.closeConfirm();
                _this.testScripts.splice(_this.deleteData.index, 1)
            }).catch((error) => {
                console.log(error)
            })
            
        },
        closeConfirm(){
            this.deleteData = {id: null, index: null, confirm: false}
        }
    },
    name: "test-script"
};
</script>
